import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import Input from '../../../../components/Input'
import Button from '../../../../components/Button'
import Errors from '../../../../components/Errors'
import Card from '../../../../components/Card'

type Props = {
  errors: Object,
  onSubmit: Function,
  submitting: boolean,
  handleSubmit: Function
}

class SettingsForm extends Component {
  props: Props

  handleSubmit = (data) => this.props.onSubmit({ user: data })

  render() {
    const { errors, handleSubmit, submitting } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Card>
          <h5>Profile</h5>
          <hr />
          <Field
            type="text"
            name="name"
            label="Name"
            component={Input}
            style={{ marginBottom: '1rem' }}
          />
          <div style={{ marginBottom: '1rem' }}>
            <Field type="text" name="email" label="Email" component={Input} />
            <Errors name="email" errors={errors} />
          </div>
          <Button color="primary" disabled={submitting} animating={submitting}>
            Update
          </Button>
        </Card>
      </form>
    )
  }
}

const validate = (values) => {
  if (!values) return {}
  const errors = {}
  if (!values.name) {
    errors.name = 'Please enter name'
  }
  if (!values.email) {
    errors.email = 'Please enter email'
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Please enter valid email'
  }
  return errors
}

export default reduxForm({
  form: 'settings',
  validate
})(SettingsForm)



// WEBPACK FOOTER //
// ./src/views/UserSettings/components/SettingsForm/index.js